import type {ReactElement} from 'react';
import {CircularProgressLoader, LOADER_COLOR, LOADER_SIZE} from '@Components/circular-progress-loader';
import {Text, TextSize, TextType} from '@Components/text';
import type {EmailVersionLoadingOverlayProps} from './email-version-loading-overlay.types';
import styles from './email-version-loading-overlay.module.scss';

export function EmailVersionLoadingOverlay({subtitle}: EmailVersionLoadingOverlayProps): ReactElement {
  return (
    <div className={styles.overlay} role="status" aria-live="polite">
      <div className={styles.content}>
        <CircularProgressLoader color={LOADER_COLOR.WHITE} size={LOADER_SIZE.MEDIUM} classes="-no-margin" />
          <div className={'flexbox flex-column-align-center'}>
            <Text val={window.i18next.t('pmwjs_fetching_version')} type={TextType.BODY} size={TextSize.LG} bold />
            <Text val={subtitle} type={TextType.BODY} size={TextSize.SM} />
          </div>
      </div>
    </div>
  );
}
